export const TRANSLATIONS_EN_DOCUMENTS_AND_DRIVE = {
  "upload.title": "Upload Documents",
  "upload.drag": "Drag and drop files here",
  "upload.select": "Select Files",
  "upload.formats": "Supported formats: PDF, DOCX, XLSX, TXT, JSON, CSV, MD",
  "upload.processing": "Processing...",
  "upload.success": "Document processed successfully",
  "upload.error": "Error processing document",
  "upload.process_immediately": "Process immediately",
  "upload.folder_name": "Folder Name",
  "upload.folder_placeholder": "Folder Name",
  "upload.tags": "Tags",
  "upload.add_tag": "Tags (comma separated)",
  "upload.viewer_role": "Viewer Role",
  "upload.role_viewer": "Viewer (default)",
  "upload.loading_roles": "Loading roles...",
  "upload.viewer_role_help": "Select the minimum role required to view this document",
  "upload.files_to_upload": "Files to upload",
  "upload.upload_all": "Upload all",
  "upload.role_id": "Access role",
  "upload.role_id_help": "Optional: restrict which role can view this document.",
  "upload.role_id_required": "Select a role.",
  "upload.select_role": "Select a role",
  "upload.queued.title": "File Queued",
  "upload.queued.message": "The file has been queued for processing.",
  "upload.queued.taskId": "Task ID",
  "upload.queued.checkTasks": "You can check the status in the tasks section.",
  "upload.duplicated.title": "Duplicate File",
  "upload.duplicated.message":
    "A document named '{{name}}' already exists. Do you want to replace it?",
  "upload.duplicated.replace": "Replace",
  "upload.success.title": "Upload Successful!",
  "upload.success.message":
    "The document '{{name}}' was successfully uploaded to the folder '{{folder}}'.",
  "documents.refresh": "Refresh",
  "documents.loading": "Loading documents...",
  "documents.name": "Name",
  "documents.source": "Source",
  "documents.vectors": "Vectors Used",
  "documents.date": "Date",
  "documents.delete_document_tooltip": "Delete document",
  "documents.delete_confirm.title": "Delete document",
  "documents.delete_confirm.body": "This action cannot be undone.",
  "documents.delete_confirm.confirm": "Delete",
  "documents.delete_confirm.error": "Could not delete the document.",
  "documents.download_document_tooltip": "Download document",
  "documents.context.ask_only_this": "Ask questions only about this document",
  "documents.context.confirm_only_this": "Limit chat to this document?",
  "documents.no_documents":
    'No indexed documents. Upload some documents in the "Upload Documents" section.',
  "documents.indexed_documents":
    "List of documents currently indexed in the system.",
  "documents.indexed_documents_title": "Indexed Documents",
  "documents.domains": "Domains",
  "documents.other_domains": "Other domains",
  "documents.documents_word": "documents",
  "documents.search_domain": "Search domain...",
  "documents.no_domain_results": "No results",
  "documents.subdomains": "Subdomains",
  "documents.clear_filter": "Clear filter",
  "documents.back": "Back",
  "documents.domain_distribution": "Domain Distribution",
  "documents.subdomain_distribution": "Subdomain Distribution for {{domain}}",
  "documents.select_domain_hint":
    "Select a domain to see its subdomains and documents.",
  "documents.select_subdomain_hint": "Select a subdomain to see its documents.",
  "documents.redirecting_to_details": "Redirecting to document details...",
  "documents.details_for_type": "Documents for type: {{type}}",
  "documents.details_for_domain": "Documents for domain: {{domain}}",
  "documents.details_all": "All documents",
  "documents.group_type": "Type",
  "documents.group_domain": "Domain",
  "documents.no_documents_in_group": "No documents in this group.",
  "documents.no_documents_found": "No documents found.",
  "documents.tab_overview": "Overview",
  "documents.tab_network": "Semantic",
  "documents.tab_details": "Details",
  "documents.tab_viewer": "Viewer",
  "documents.sidebar_types": "Types",
  "documents.types_distribution": "Types Distribution",
  "documents.type_.pdf": "PDF",
  "documents.type_.docx": "DOCX",
  "documents.type_.txt": "TXT",
  "documents.type_.csv": "CSV",
  "documents.type_.xlsx": "XLSX",
  "documents.type_.pptx": "PPTX",
  "documents.type_.email": "Email",
  "documents.type_.other": "Other",
  "documents.type_.md": "MD",
  "documents.group_last3days": "Last 3 days",
  "documents.group_lastweek": "Last week",
  "documents.group_lastmonth": "Last month",
  "documents.group_older": "Older",
  "drive.viewer_aria_label": "My Drive viewer (read-only)",
  "drive.search_placeholder": "Search in My Drive",
  "drive.my_drive": "My Drive",
  "drive.filter.type.aria": "Filter by type",
  "drive.filter.type.label_all": "Type: All",
  "drive.type.folder": "Folder",
  "drive.type.doc": "Document",
  "drive.type.sheet": "Spreadsheet",
  "drive.type.slide": "Presentation",
  "drive.type.pdf": "PDF",
  "drive.type.image": "Image",
  "drive.type.video": "Video",
  "drive.type.zip": "ZIP",
  "drive.type.other": "Others",
  "drive.filter.owner.aria": "Filter by owner",
  "drive.filter.owner.label_all": "Owner: Any",
  "drive.owner.you": "You",
  "drive.owner.external": "External",
  "drive.owner.any": "Any",
  "drive.details": "Details",
  "drive.tree_aria_label": "My Drive tree",
  "drive.breadcrumbs_aria_label": "Current path",
  "drive.view.list": "List",
  "drive.view.grid": "Grid",
  "drive.view.list_aria": "List view",
  "drive.view.grid_aria": "Grid view",
  "drive.sort.by": "Sort by",
  "drive.sort.dir": "Sort direction",
  "drive.sort.key.name": "Name",
  "drive.sort.key.type": "File type",
  "drive.sort.key.owner": "Owner",
  "drive.sort.key.modified": "Last modified",
  "drive.sort.key.size": "Size",
  "drive.dir.asc": "Asc",
  "drive.dir.desc": "Desc",
  "drive.results_showing": "Showing",
  "drive.table.aria_label": "Items list",
  "drive.table.name": "Name",
  "drive.table.file_type": "File type",
  "drive.table.owner": "Owner",
  "drive.table.last_modified": "Last modified",
  "drive.table.size": "Size",
  "drive.shared": "Shared",
  "drive.preview": "Preview",
  "drive.details.name": "Name",
  "drive.details.type": "Type",
  "drive.details.location": "Location",
  "drive.details.owner": "Owner",
  "drive.details.size": "Size",
  "drive.details.created": "Created",
  "drive.details.last_modified": "Last modified",
  "drive.details.shared": "Shared",
  "drive.yes": "Yes",
  "drive.no": "No",
  "drive.details.permissions": "Permissions",
  "drive.permissions.read_only": "Read-only",
  "drive.no_selection_hint": "Select an item to see its details.",
  "drive.filters_aria": "Filters",
  "drive.hide_tree": "Hide tree",
  "drive.show_tree": "Show tree",
  "drive.refreshing": "Refreshing...",
  "drive.loading_files": "Loading files...",
  "drive.preview.loading": "Loading preview...",
  "drive.preview.not_available": "Preview not available",
  "drive.by_date": "By date",
  "drive.status.items": "items",
  "drive.status.items_one": "item",
  "drive.status.of": "of",
  "drive.status.selected": "selected",
  "drive.status.selected_one": "selected",
  "drive.type.email": "Email",
  "drive.context.move_to": "Move to",
  "drive.context.no_move_targets": "No folders available",
  "drive.move_dialog.title": "Move documents",
  "drive.move_dialog.search": "Search folders",
  "drive.move_dialog.items_suffix": "items",
  "drive.move_dialog.moving": "Moving...",
  "drive.move_dialog.error": "The file could not be moved. Check permissions or try again.",
  "drive.move_dialog.invalid_target": "Select a valid destination folder.",
  "drive.bytes": "bytes",
  "documents.error_loading": "Error loading documents",
  "documents.error_deleting": "Error deleting document",
  "documents.selected_type": "Selected type",
  "documents.selected_document": "Selected document",
  "documents.group_today": "Today",
  "documents.group_lastWeek": "Last week",
  "documents.group_lastMonth": "Last month",
  "upload.clear_completed": "Clear completed",
  "drive.contextMenu.generateSummary": "Generate Summary",
  "drive.generateSummary.modalTitle": "Selected documents",
  "drive.generateSummary.modalHint": "An executive summary of these documents will be generated.",
  "drive.generateSummary.goToGenerate": "Go to Generate",
  "drive.generateSummary.noDocuments": "Select at least one indexed document.",
  "documents.versions.action": "Version history",
  "documents.versions.title": "Version history",
  "documents.versions.empty": "This document has no versions yet.",
  "documents.versions.error": "Could not load the version history.",
  "documents.versions.active": "Current",
  "documents.versions.close": "Close",
};
